export default "__VITE_ASSET__165af0b2__"